import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { backgroundNavbar } from './styles';
import brandIcon from './assets/feb-brand.png';

const NavbarAdmin = ({ logout, role }) => (
  <Navbar collapseOnSelect expand="lg" className={backgroundNavbar}>
    <Navbar.Brand href="#home">
      <img
        src={brandIcon}
        className="d-inline-block align-top"
        alt="Icon FEB UI"
      />
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
      <Nav className="ml-auto">
        <Nav.Link href="/">Home</Nav.Link>
        <Nav.Link href="/Admin/BuatKum">Buat KUM</Nav.Link>
        <Nav.Link href="/Admin/PengajuanKuliahUmum/DaftarPengajuan">Daftar Pengajuan KUM</Nav.Link>
        <Nav.Link href="/Admin/HistoriKum">Histori Kegiatan KUM</Nav.Link>
        <Nav.Link href="/Admin/DaftarPengajuanPartisipasi/DaftarApprovalPartisipasi">Daftar Klaim KUM</Nav.Link>
        <Nav.Link href="/Admin/PemeriksaanMahasiswa">Cek Partisipasi</Nav.Link>
        { role === 'superadmin'
          ? (
            <Nav.Link href="/Superadmin/RegistrasiAdmin">Tambah Admin</Nav.Link>
          )
          : (
            <>
            </>
          )}
        <Navbar.Text className="welcome">
          {`Selamat Datang ${localStorage.getItem('nama')}`}
        </Navbar.Text>
        <Nav.Link>
          <Button variant="danger" onClick={logout} style={{ backgroundColor: '#B23B3B', color: '#F5F6F8', borderColor: '#B23B3B' }}>Log Out</Button>
        </Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);

NavbarAdmin.defaultProps = {
  logout: () => 'do nothing',
  role: 'admin',
};

NavbarAdmin.propTypes = {
  logout: PropTypes.func,
  role: PropTypes.string,
};

export default NavbarAdmin;
